import { useState, useCallback } from 'react';
import { EvidencePackage } from '@chess-platform/shared';

export interface AIExplanationRequest {
    evidence: EvidencePackage;
    provider?: string;
    apiKey?: string;
}

export function useAIFeedback() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getExplanation = useCallback(async (data: AIExplanationRequest): Promise<any | null> => {
        setLoading(true);
        setError(null);
        try {
            const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:3000';
            const response = await fetch(`${apiBase}/ai/explain`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Error al obtener la explicación de la IA');
            }

            const result = await response.json();
            // result.explanation is now a JSON string from the backend
            try {
                return JSON.parse(result.explanation);
            } catch {
                return result.explanation;
            }
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Error desconocido';
            setError(message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return { getExplanation, loading, error };
}
